import React, { ReactElement } from "react";
import { Box, Button, ListItem } from "@mui/material";

interface Props {
  title: string;
  icon?: ReactElement;
  onClick: () => void;
  rest?: any[];
}

const HelpNavItem = ({ icon, title, onClick, ...rest }: Props): JSX.Element => {
  return (
    <ListItem
      disableGutters
      {...rest}
      sx={{
        display: "flex",
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: 1,
      }}
    >
      <Button
        sx={{
          color: "text.primary",
          fontWeight: "fontWeightRegular",
          justifyContent: "flex-start",
          letterSpacing: 0,
          padding: "3px 0 2px 18px",
          textTransform: "none",
          width: "100%",
          borderRadius: 0,
          "&:hover": {
            color: "text.primary",
            backgroundColor: "rgba(111, 121, 212, 0.08)",
          },
        }}
        onClick={onClick}
        disableRipple={true}
      >
        <Box
          component="span"
          sx={{
            margin: "8px 20px 0 0",
            opacity: "0.5",
          }}
          className="icon"
        >
          {icon}
        </Box>
        <Box
          component="span"
          sx={{
            marginRight: "auto",
            fontSize: 14,
          }}
        >
          {title}
        </Box>
      </Button>
    </ListItem>
  );
};

export default HelpNavItem;
